import { Routes, Route, Navigate } from 'react-router-dom';
import { FiltersList, FiltersAddEdit } from '.';

export { FiltersLayout };

function FiltersLayout() {

    return (
        <div className="pt-16">
            <div className="container">
                <Routes>
                    <Route index element={<FiltersList />} />
                    <Route path="add" element={<FiltersAddEdit />} />
                    <Route path="edit/:filterid" element={<FiltersAddEdit />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </div>
    );
}
